import { OTA_Error } from "./ota_error.model";
import { OTA_VehRetResRSCore } from "./ota_vehretresrscore.model";

export class OTA_VehRetResRS {
    //public target: string;
    //public version: string;
    //public retransmissionIndicator: string;
    //public echoToken: string;
    public success: boolean;
    public vehRetResRSCore = new OTA_VehRetResRSCore();
    public errors = new Array<OTA_Error>();
}